import { UnauthorizedComponent } from './unauthorized.component';
import { CommonModule } from '@angular/common';

import { Route, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

const routes: Route[] = [
  {
    path: 'forbidden',
    pathMatch: 'full',
    component: UnauthorizedComponent,
  },
];

@NgModule({
  imports: [CommonModule, RouterModule.forChild(routes)],
})
export class UnauthorizedModule {}
